import React, { ReactNode, useEffect, useState } from 'react';
import Header from './Header';
import Footer from './Footer';
import SecretPopout from '../Secret/SecretPopout';
import { useBetterAuthConvexAuth } from '../../hooks/useAppAuth';

interface LayoutProps {
  children: ReactNode;
}

const Layout: React.FC<LayoutProps> = ({ children }) => {
  const { convexUser, isLoaded, isSignedIn, isLoadingProfile } = useBetterAuthConvexAuth();
  const [sessionId, setSessionId] = useState('');

  useEffect(() => {
    // Generate or retrieve session ID
    let id = localStorage.getItem('secret_session_id');
    if (!id) {
      id = `session_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
      localStorage.setItem('secret_session_id', id);
    }
    setSessionId(id);
  }, []);

  // Only show popout for customers or non-logged in users once auth state is settled.
  const showPopout =
    isLoaded &&
    !isLoadingProfile &&
    (!isSignedIn || convexUser?.role === 'customer');

  return (
    <div className="min-h-screen flex flex-col bg-gray-50">
      <Header />

      <main className="flex-1">
        {children}
      </main>
      <Footer />

      {sessionId && showPopout && <SecretPopout sessionId={sessionId} />}
    </div>
  );
};

export default Layout;
